var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 6L9 17L4 12","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Check;

Check.default = Check;
